import React from "react";
import { isArray } from "lodash";
import { _getBaseUrl, _getTranslation } from "../utils/helper";
import { compileString } from "sass";

const CardLibrary = ({ data, ...props }) => {
  let day, month;

  if (data.datum && data.datum !== "") {
    const parts = data.datum.split("<br>");
    day = parts[0].trim();
    month = parts[1].trim();
  }

  const doodle = _getBaseUrl("themes/custom/tema/src/assets/patterns/hover-bg.svg");

  return (
    <article className="library-card group h-full w-full hover:no-underline gap-5">
      <a href={data.permalink}>
        <div className="w-full relative">

          {/* Background on hover - behind the image */}
          <div
            className="absolute inset-[-10%] scale-110 bg-cover bg-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"
            style={{ backgroundImage: `url(${doodle})` }}
          ></div>

          <div className="image relative overflow-hidden z-10">
            {data.imageUrl ? (
              <img
                src={data.imageUrl}
                alt={data.imageAlt}
                className="filter grayscale group-hover:grayscale-0 w-full h-full"
              />
            ) : null}
          </div>


          {data.status && data.status.length > 0 && (
            <span
              className="text-sm scale-text-150:text-lg scale-text-200:text-[22px] absolute top-3 left-3 w-auto mb-4 py-1 px-4 rounded-full border text-white bg-black border-black
            flex items-center justify-center"
            >
              {data.status}
            </span>
          )}
          {data.datum && data.datum !== "" && (
            <span className="text-center font-sharpgrotesk absolute top-3 left-3 w-auto mb-4 py-1 px-4 rounded-[16px] border text-white bg-cirGold border-cirGold flex flex-col items-center justify-center">
              <span className="text-xl scale-text-150:text-2xl scale-text-200:text-3xl">
                {day}
              </span>
              <span className="text-base scale-text-150:text-lg scale-text-200:text-xl">
                {month}
              </span>
            </span>
          )}
        </div>
        <div className="w-full">
          {isArray(data.onderwerpen) &&
            data.onderwerpen.length > 0 &&
            isArray(data.gebieden) &&
            data.gebieden.length > 0 && (
              <ul className="flex flex-wrap items-center gap-2 pt-4 md:my-4">
                {data.onderwerpen.length > 0 &&
                  data.onderwerpen.map((onderwerp, index) => (
                    <li key={index} className="font-magicb font-normal text-sm md:marker:text-15 uppercase bg-gewGrey px-3 py-1">
                      {onderwerp}
                    </li>
                  ))}

                {data.gebieden.length > 0 &&
                  data.gebieden.map((gebieden, index) => (
                    <li key={index} className="font-magicb font-normal text-sm md:marker:text-15 uppercase bg-gewGrey px-3 py-1">
                      {gebieden}
                    </li>
                  ))}
              </ul>
            )}
          <h2 className="h4 font-normal font-franklin pt-4 md:pt-1 flex flex-col-reverse">
            {data.title}
            {data.date !== "" && (
              <span className="h6 pb-1 md:pb-2">{data.date}</span>
            )}
          </h2>
          <div className="pb-4">
            {data.text}
          </div>
          <div className="btn w-full md:w-fit">
            <span className="button-gew inline-block text-center btn-small text-white text-sm md:text-base uppercase">Lees verder</span>
          </div>

        </div>
      </a>

    </article>
  );
};

export default CardLibrary;
